<template> 
<div>
    <span v-for="(item, index) in temp_data" :key="index">
    <span :class="statusBadgeClass(item.Status)" >
    {{ item.Num }} {{ statusTranslation(item.Status) }}
    </span>
    </span> 
 </div>
</template>
<script>
export default {
    props: ["data"],
    created() {

    },
    data() {
        return {
             
        }
    },
    computed: {
        langid() {
            return localStorage.getItem('currentLangId');
        },
        statusBadgeClass() {
            return (status) => {
                const classMap = {
                    'Unsubmitted': 'ad badge-secondary',
                    'Pending': 'ad badge-info',
                    'AiReviewing': 'ad badge-ai-reviewing',
                    'PendingManualAudit': 'ad badge-pending-manual',
                    'Rejected': 'ad badge-danger',
                    'Disabled': 'ad badge-dark',
                    'Offline': 'ad badge-expired',
                    'Active': 'ad badge-success',
                    'Activated': 'ad badge-success',
                    'PendingGoLive': 'ad badge-pending-go-live',
                    'Expired': 'ad badge-expired',
                    'NoAd': 'ad badge-light'
                };
                return classMap[status] || 'badge badge-secondary';
            };
        },
        // 获取状态对应的翻译
        statusTranslation() {
            return (status) => {
                const translationMap = {
                    'Unsubmitted': this.$t("lbl_EMPBE_Unsubmitted"),
                    'Pending': this.$t("lbl_EMPBE_Ad_Status_Pending"),
                    // 兼容旧汇总串中的 AiReviewing，统一显示为审批中
                    'AiReviewing': this.$t("lbl_EMPBE_Ad_Status_Pending"),
                    'PendingManualAudit': this.$t("lbl_EMPBE_Ad_Status_PendingManualAudit"),
                    'Rejected': this.$t("lbl_EMPBE_Rejected"),
                    'Disabled': this.$t("lbl_EMPBE_Stopped"),
                    'Offline': this.$t("lbl_EMPBE_Offline"),
                    'Active': this.$t("lbl_EMPBE_isActivate"),
                    'Activated': this.$t("lbl_EMPBE_isActivate"),
                    'PendingGoLive': this.$t("lbl_EMPBE_Ad_Status_PendingGoLive"),
                    'Expired': this.$t("lbl_EMPBE_Ad_Status_Expired"),
                    'NoAd': this.$t("lbl_EMPBE_NoAd")
                };
                return translationMap[status] || status;
            };
        },
        temp_data(){
            //14|Pending, 8|Activated
            if(this.data){
                let arrayData=this.data.split(',');
                return arrayData.map(item => { 
                    const trimmedItem = item.trim(); 
                    const parts = trimmedItem.split('|'); 
                    if (parts.length >= 2) {
                        return {
                            Num: parts[0].trim(),     
                            Status: parts[1].trim()    
                        };
                    } else { 
                        console.warn('数据格式不正确:', item);
                        return {
                            Num: '0',
                            Status: '-'
                        };
                    }
                }).filter(item => item && Number(item.Num) > 0);
            }
           return [];

        }
    }
}
</script>
